import { InputSelectionListProps, Tag, Text } from '@dixa/lib-shared-habla';
import { HookFormFieldWrappedBaseProps } from 'lib-shared-hook-form';
import type { Tag as TagT } from 'lib-shared-types-api';
import { FieldPath, FieldValues } from 'react-hook-form';

import { HookFormSearchSelect } from 'components/hookForm/hookFormSearchSelect';

import styles from './hookFormTagSelect.module.scss';

type HookFormTagSelectProps = Partial<
  Omit<InputSelectionListProps<TagT>, 'children'>
>;

export const HookFormTagSelect = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  componentProps = {},
  ...listProps
}: HookFormFieldWrappedBaseProps<
  TFieldValues,
  TName,
  HookFormTagSelectProps
>): JSX.Element => {
  return (
    <HookFormSearchSelect
      {...listProps}
      scope="tags"
      initialArg={{
        sortBy: { field: 'name', order: 'asc' },
      }}
      renderSelectionListItemContent={(tag) => (
        <Tag color={tag.color ?? undefined} noBorder className={styles.tag}>
          {tag.name}
        </Tag>
      )}
      componentProps={{
        multiple: true,
        placeholder: 'Select tags',
        equalityFn: (a: TagT, b: TagT) => a.id === b.id,
        getItemTitleByValue: (tag: TagT | null | undefined) =>
          tag ? (
            <Tag color={tag.color} noBorder className={styles.tag}>
              {tag.name}
            </Tag>
          ) : (
            <Text.Paragraph>Unknown</Text.Paragraph>
          ),
        ...componentProps,
      }}
    />
  );
};
